"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themePropDefs = void 0;
const as_child_prop_js_1 = require("./as-child.prop.js");
const radix_colors_js_1 = require("../radix-colors.js");
const appearances = ['inherit', 'light', 'dark'];
const accentColors = [...radix_colors_js_1.radixColorScales, 'gray'];
const grayColors = [...radix_colors_js_1.radixGrayScales, 'auto'];
const panelBackgrounds = ['solid', 'translucent'];
const radii = ['none', 'small', 'medium', 'large', 'full'];
const scalings = ['90%', '95%', '100%', '105%', '110%'];
const themePropDefs = {
    asChild: as_child_prop_js_1.asChildProp,
    hasBackground: { type: 'boolean', default: true },
    appearance: { type: 'enum', values: appearances, default: 'inherit' },
    accentColor: { type: 'enum', values: accentColors, default: 'indigo' },
    grayColor: { type: 'enum', values: grayColors, default: 'auto' },
    panelBackground: { type: 'enum', values: panelBackgrounds, default: 'translucent' },
    radius: { type: 'enum', values: radii, default: 'medium' },
    scaling: { type: 'enum', values: scalings, default: '100%' },
};
exports.themePropDefs = themePropDefs;
//# sourceMappingURL=theme.props.js.map